import { ApiInstance, RetrySettings } from '@src/services/api-instance';
import { getAuthToken } from '@src/services/auth-service';
import { GetTeamMembersResponseDTO } from './dto/brain-team-members.get.response.dto';

export class BrainTeamMembersService {
  private readonly client: ApiInstance;

  constructor(client: ApiInstance) {
    this.client = new ApiInstance(`${client.getBaseUrl()}/team-members`, client.getTimeout());
  }

  async get(request: {
    params?: {
      currentPage?: number;
      limit?: number;
      paginate?: boolean;
    };
    settings?: RetrySettings;
  }): Promise<GetTeamMembersResponseDTO> {
    return (
      await this.client.get<GetTeamMembersResponseDTO>(``, request.params, {
        bearerToken: await getAuthToken(),
        settings: request.settings,
      })
    ).data;
  }
}
